export default __webpack_public_path__ + "images/306eca0802e12407e2c180a491d9323e-social_media.jpg";